import { typography, radius } from '@/shared/theme/tokens';
import { BOARD } from './boardTheme';

const MONO = BOARD.mono;

/**
 * Shared board chrome: a destinations-board section header and the small
 * gate-tag + empty state reused by the recommendation and alert boards.
 */
export function SectionHeader({ title, count, accent = BOARD.amber, columns = [] }) {
  return (
    <div style={{ flexShrink: 0, background: BOARD.chrome, borderBottom: `1px solid ${BOARD.rule}` }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px' }}>
        <span style={{ width: 8, height: 20, borderRadius: radius.xs, background: accent, flexShrink: 0 }} />
        <span style={{
          fontFamily: typography.fontFamily.heading, fontSize: typography.fontSize['4xl'],
          fontWeight: typography.fontWeight.extrabold, letterSpacing: typography.letterSpacing.label,
          textTransform: 'uppercase', color: BOARD.ink,
        }}>
          {title}
        </span>
        {typeof count === 'number' && (
          <span style={{
            marginLeft: 'auto', fontFamily: MONO, fontSize: typography.fontSize.lg,
            fontWeight: typography.fontWeight.bold, letterSpacing: typography.letterSpacing.wide,
            color: accent, fontVariantNumeric: 'tabular-nums',
          }}>
            {String(count).padStart(2, '0')}
          </span>
        )}
      </div>
      {columns.length > 0 && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 12, padding: '0 16px 7px',
          fontFamily: MONO, fontSize: typography.fontSize.xs, fontWeight: typography.fontWeight.bold,
          letterSpacing: typography.letterSpacing.widest, textTransform: 'uppercase', color: BOARD.inkFaint,
        }}>
          {columns.map((col) => (
            <span key={col.label} style={{ flex: col.flex, textAlign: col.align ?? 'left', minWidth: 0 }}>{col.label}</span>
          ))}
        </div>
      )}
    </div>
  );
}

export function Tag({ color, children, solid = false }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', fontFamily: MONO, fontSize: typography.fontSize.xs,
      fontWeight: typography.fontWeight.bold, letterSpacing: typography.letterSpacing.wide, textTransform: 'uppercase',
      color: solid ? BOARD.wall : color, background: solid ? color : 'transparent',
      border: `1px solid ${color}`, borderRadius: radius.xs, padding: '2px 7px', whiteSpace: 'nowrap', flexShrink: 0,
    }}>
      {children}
    </span>
  );
}

export function Empty({ icon, color, text, sub }) {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, textAlign: 'center', padding: 28 }}>
      <span className="material-symbols-outlined" style={{ fontSize: 40, color }}>{icon}</span>
      <span style={{
        fontFamily: typography.fontFamily.heading, fontSize: typography.fontSize['3xl'], fontWeight: typography.fontWeight.extrabold,
        letterSpacing: typography.letterSpacing.label, textTransform: 'uppercase', color: BOARD.ink,
      }}>
        {text}
      </span>
      <span style={{ fontFamily: MONO, fontSize: typography.fontSize.sm, color: BOARD.inkFaint, maxWidth: 320, lineHeight: 1.5 }}>{sub}</span>
    </div>
  );
}
